import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  RESET_USER_STATE,
} from '../../../redux/types/user';

const initialState = {
  loading: false,
  users: [],
  error: null,
  success: false,
};

const fetchUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        success: true,
      };

    case FETCH_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case RESET_USER_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default fetchUserReducer;
